import { FieldType } from '@ngx-formly/core';
import { Component, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'phdsoft-form-flex-layout',
  template: `
    <div class="content">
      <formly-field *ngFor="let f of field.fieldGroup" class="formly-field" [field]="f">
      </formly-field>
    </div>
  `,
  styles: [`
    .content {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      gap: 10px;
      width: 100%;
    }

    @media screen and (max-width: 600px) {
      .content {
        flex-direction: column;
      }
    }

    .formly-field {
      flex: 1 1 auto;
    }
  `]
})
export class PhdSoftFormFlexLayoutComponent extends FieldType {
}
